/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  AdsFeedControllerGetGoogleAdsPagesFeedQueryResponse,
  AdsFeedControllerGetGoogleAdsPagesFeedPathParams,
} from '../../types/AdsFeedControllerGetGoogleAdsPagesFeed.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { adsFeedGetGoogleAdsPagesFeed } from '../../methods/adsFeedGetGoogleAdsPagesFeed.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const adsFeedGetGoogleAdsPagesFeedQueryKey = (
  wlDomain: AdsFeedControllerGetGoogleAdsPagesFeedPathParams['wlDomain'],
) => [{ url: '/api/ads-feed/:wlDomain/google-ads-pages.csv', params: { wlDomain: wlDomain } }] as const;

export type AdsFeedGetGoogleAdsPagesFeedQueryKey = ReturnType<typeof adsFeedGetGoogleAdsPagesFeedQueryKey>;

export function adsFeedGetGoogleAdsPagesFeedQueryOptions(
  wlDomain: AdsFeedControllerGetGoogleAdsPagesFeedPathParams['wlDomain'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = adsFeedGetGoogleAdsPagesFeedQueryKey(wlDomain);
  return queryOptions<
    AdsFeedControllerGetGoogleAdsPagesFeedQueryResponse,
    ResponseErrorConfig<Error>,
    AdsFeedControllerGetGoogleAdsPagesFeedQueryResponse,
    typeof queryKey
  >({
    enabled: !!wlDomain,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return adsFeedGetGoogleAdsPagesFeed(wlDomain, config);
    },
  });
}

/**
 * {@link /api/ads-feed/:wlDomain/google-ads-pages.csv}
 */
export function useAdsFeedGetGoogleAdsPagesFeed<
  TData = AdsFeedControllerGetGoogleAdsPagesFeedQueryResponse,
  TQueryData = AdsFeedControllerGetGoogleAdsPagesFeedQueryResponse,
  TQueryKey extends QueryKey = AdsFeedGetGoogleAdsPagesFeedQueryKey,
>(
  wlDomain: AdsFeedControllerGetGoogleAdsPagesFeedPathParams['wlDomain'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        AdsFeedControllerGetGoogleAdsPagesFeedQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? adsFeedGetGoogleAdsPagesFeedQueryKey(wlDomain);

  const query = useQuery(
    {
      ...adsFeedGetGoogleAdsPagesFeedQueryOptions(wlDomain, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
